import React, { useEffect, useState } from 'react';
import './ActivityFeed.css';

const USER_PROVIDED_ACTIVITIES = [
  { id: 'provided-purchase-1', type: 'purchase', initial: 'P', city: 'Mumbai', timeLabel: '24 min ago' },
  { id: 'provided-decision-1', type: 'decision', status: 'approved', visaType: 'Critical Skills', reference: 'ND****7821', timeLabel: '5 min ago' },
  { id: 'provided-decision-2', type: 'decision', status: 'approved', visaType: 'Study visa', reference: 'ND****5832', timeLabel: '37 min ago' },
  { id: 'provided-purchase-2', type: 'purchase', initial: 'A', city: 'Bangalore', timeLabel: '30 min ago' },
  { id: 'provided-decision-3', type: 'decision', status: 'approved', visaType: 'Work permit', reference: 'ND****2847', timeLabel: '17 min ago' },
  { id: 'provided-purchase-3', type: 'purchase', initial: 'R', city: 'Delhi', timeLabel: '33 min ago' },
  { id: 'provided-decision-4', type: 'decision', status: 'approved', visaType: 'Family visa', reference: 'ND****6453', timeLabel: '32 min ago' },
  { id: 'provided-decision-5', type: 'decision', status: 'approved', visaType: 'Student visa', reference: 'ND****3341', timeLabel: '11 min ago' },
  { id: 'provided-purchase-4', type: 'purchase', initial: 'S', city: 'Pune', timeLabel: '33 min ago' },
  { id: 'provided-decision-6', type: 'decision', status: 'refused', visaType: 'Tourist visa', reference: 'ND****9124', timeLabel: '13 min ago' },
  { id: 'provided-purchase-5', type: 'purchase', initial: 'A', city: 'Bangalore', timeLabel: '17 min ago' },
  { id: 'provided-decision-7', type: 'decision', status: 'approved', visaType: 'Work visa', reference: 'ND****8892', timeLabel: '35 min ago' }
];

const ActivityFeed = ({ suppress = false }) => {
  const [visible, setVisible] = useState(false);
  const [rotation, setRotation] = useState(0);
  let hasPaidIdentity = suppress;
  try {
    hasPaidIdentity = hasPaidIdentity || sessionStorage.getItem('isPremiumUser') === 'true'
      || !!localStorage.getItem('userEmail');
  } catch (_) { /* The verified access prop still suppresses paid users. */ }

  useEffect(() => {
    if (hasPaidIdentity) return;
    let hideTimer;
    const show = () => {
      setVisible(true);
      setRotation(previous => previous + 1);
      clearTimeout(hideTimer);
      hideTimer = setTimeout(() => setVisible(false), 8000);
    };
    const firstShow = setTimeout(show, 4000);
    const repeat = setInterval(show, 18000);
    return () => {
      clearTimeout(firstShow);
      clearInterval(repeat);
      clearTimeout(hideTimer);
    };
  }, [hasPaidIdentity]);

  if (hasPaidIdentity) return null;
  const activity = USER_PROVIDED_ACTIVITIES[(rotation - 1 + USER_PROVIDED_ACTIVITIES.length) % USER_PROVIDED_ACTIVITIES.length];

  return (
    <div className={`activity-feed ${visible ? 'visible' : ''}`} aria-hidden={!visible}>
      <div className="activity-item" key={activity.id}>
        {activity.type === 'decision' ? (
          <>
            <div className={`activity-icon decision-icon ${activity.status}`} aria-hidden="true">📋</div>
            <div className="activity-content">
              <div className="activity-text">
                <span className={`status-badge ${activity.status}`}>
                  {activity.status === 'approved' ? 'Approved' : 'Refused'}
                </span>
                <strong>{activity.visaType}</strong>
                <span className="reference-number">Ref: {activity.reference}</span>
              </div>
              <div className="activity-time">{activity.timeLabel}</div>
            </div>
          </>
        ) : (
          <>
            <div className="activity-icon upgrade-icon" aria-hidden="true">💎</div>
            <div className="activity-content">
              <div className="activity-text">
                <strong aria-label={`${activity.initial}, remaining name obscured`}>
                  {activity.initial}<span className="activity-name-obscured" aria-hidden="true">****</span>
                </strong>
                <span>from {activity.city} upgraded to premium</span>
              </div>
              <div className="activity-time">{activity.timeLabel}</div>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default ActivityFeed;
